import { LinearProgress } from '@hyperflake/react-ui-library';
import UpdateAssetPurchaseOrderForm from 'modules/asset-purchase-order/components/UpdateAssetPurchaseOrderForm/UpdateAssetPurchaseOrderForm';
import useAssetPurchaseOrderData from 'modules/asset-purchase-order/hooks/useAssetPurchaseOrderData';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import UpdateSiteRecceForm from 'modules/site-recce/components/UpdateSiteRecceForm/UpdateSiteRecceForm';
import useSiteRecceData from 'modules/site-recce/hooks/useSiteRecceData';

import { useParams } from 'react-router-dom';

const UpdateAssetPurchaseOrderPage = () => {
    const { clientInstallationId, projectInstallationId, purchaseOrderId } = useParams();
    const {
        purchaseOrderData: initialData,
        isLoading,
        setData,
    } = useAssetPurchaseOrderData(clientInstallationId!, projectInstallationId!, purchaseOrderId);
    return (
        <>
            {isLoading ? (
                <LinearProgress />
            ) : (
                <PageTemplate>
                    <PageHeading>Update Purchase Order</PageHeading>
                    <UpdateAssetPurchaseOrderForm
                        clientInstallationId={clientInstallationId}
                        projectInstallationId={projectInstallationId}
                        initialData={initialData}
                        setData={setData}
                    />
                </PageTemplate>
            )}
        </>
    );
};

export default UpdateAssetPurchaseOrderPage;
